/**
 * Landing feature flags. Same conventions as the webapp's
 * apps/app/src/lib/feature-flags.ts: name flags by feature, keep the prod
 * default in a constant, and let one browser override it through
 * localStorage for review.
 */

/**
 * DEV-12905: /pricing with the "Pay as you go | Subscription" choice
 * (Paper, Pricing, page 1). The credits backend does not exist yet
 * (DEV-12910), so the PAYG checkout is not wired.
 *
 * On lunarcrush.com: `PAYG_PRICING_LIVE` (true since Oct 26, 2026: PAYG launch; false kept the
 * current subscriptions-only page). Local and `*.pages.dev` staging run the
 * new layout. `localStorage["lc-payg-pricing"]` overrides both on one
 * browser: "on" shows the new layout, "off" the current one.
 */
export const PAYG_PRICING_LIVE = true;

const PAYG_OVERRIDE_KEY = 'lc-payg-pricing';

function isReviewHost(host: string): boolean {
  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.pages.dev');
}

export function paygPricingEnabled(): boolean {
  // Prerender / SSR: no window, render the released page.
  if (typeof window === 'undefined') return PAYG_PRICING_LIVE;
  try {
    const forced = window.localStorage.getItem(PAYG_OVERRIDE_KEY);
    if (forced === 'on') return true;
    if (forced === 'off') return false;
  } catch {
    // Storage blocked: fall through to the host rule.
  }
  if (isReviewHost(window.location.hostname)) return true;
  return PAYG_PRICING_LIVE;
}

/**
 * Pricing v3 (Nov 4 2026, Jon + Nico): /pricing only explains the two ways to
 * pay and has one GET STARTED; the choice moves into the app, as the first
 * step after sign-up (apps/app pricingFirstEnabled). Off on lunarcrush.com
 * until Nico approves the release; on for local and `*.pages.dev` review.
 * `localStorage["lc-pricing-v3"]` = "on" / "off" overrides on one browser.
 */
export const PRICING_V3_LIVE = true; // Released Nov 5 2026 (Nico)

export function pricingV3Enabled(): boolean {
  if (typeof window === 'undefined') return PRICING_V3_LIVE;
  try {
    const forced = window.localStorage.getItem('lc-pricing-v3');
    if (forced === 'on') return true;
    if (forced === 'off') return false;
  } catch {
    // Storage blocked: fall through to the host rule.
  }
  if (isReviewHost(window.location.hostname)) return true;
  return PRICING_V3_LIVE;
}
